import { ResourcePriority, ResourceType, } from '../../models/resource';
export class ResourceService {
    constructor(resources = []) {
        this.resources = {};
        this.defaultComparator = (resource1, resource2) => {
            const resource1Priority = resource1.priority || ResourcePriority.Default;
            const resource2Priority = resource2.priority || ResourcePriority.Default;
            const diff = resource1Priority - resource2Priority;
            return diff || resource1.key.localeCompare(resource2.key);
        };
        resources.forEach((resource) => {
            this.resources[resource.key] = resource;
        });
    }
    async init(resourceDescriptors = []) {
        await Promise.all(resourceDescriptors.map((resource) => this.addResource(resource)));
    }
    async addResources(resourceDescriptors) {
        await Promise.all(resourceDescriptors.map((descriptor) => this.addResource(descriptor)));
    }
    async addResource(resourceDescriptor) {
        const cachedResource = this.resources[resourceDescriptor.key];
        if (cachedResource) {
            return;
        }
        const resource = await this.queryResource(resourceDescriptor);
        this.resources[resource.key] = resource;
    }
    getTranslations(locale, ...tags) {
        return this.getTranslationResources(locale, ...tags).map((resource) => resource.value);
    }
    getModuleTranslations(module, locale, ...tags) {
        return this.getTranslationResources(locale, ...tags)
            .filter((resource) => resource.module === module)
            .map((resource) => resource.value);
    }
    getResources() {
        return Object.values(this.resources).sort(this.defaultComparator);
    }
    getTranslationResources(locale, ...tags) {
        return this.getResources().filter((resource) => {
            return (resource.type === ResourceType.TRANSLATION &&
                resource.locale === locale &&
                (tags.length ? tags.some((tag) => { var _a; return (_a = resource === null || resource === void 0 ? void 0 : resource.tags) === null || _a === void 0 ? void 0 : _a.includes(tag); }) : resource));
        });
    }
    async queryResource(resourceDescriptor) {
        let resource;
        if (resourceDescriptor.value) {
            resource = resourceDescriptor;
        }
        else {
            resource = await fetch(resourceDescriptor.key)
                .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else {
                    return {};
                }
            })
                .then((value) => (Object.assign(Object.assign({}, resourceDescriptor), { value })))
                .catch((e) => {
                /* eslint no-console: "error" */
                // tslint:disable-next-line:no-console
                console.error('Failed to fetch resource', e.message, resourceDescriptor);
                return Object.assign(Object.assign({}, resourceDescriptor), { value: null });
            });
        }
        return resource;
    }
}
//# sourceMappingURL=resource.service.js.map